export const countryCodeList = [
    { code: "+93", name: "Afghanistan", length: 9 },
    { code: "+355", name: "Albania", length: 9 },
    { code: "+213", name: "Algeria", length: 9 },
    { code: "+376", name: "Andorra", length: 6 },
    { code: "+244", name: "Angola", length: 9 },
    { code: "+1", name: "Antigua and Barbuda", length: 10 },
    { code: "+54", name: "Argentina", length: 10 },
    { code: "+680", name: "Palau", length: 7 },
    { code: "+1", name: "United States", length: 10 },
    { code: "+1", name: "Canada", length: 10 },
    { code: "+502", name: "Guatemala", length: 8 },
    { code: "+295", name: "Aruba", length: 7 },
    { code: "+43", name: "Austria", length: 10 },
    { code: "+61", name: "Australia", length: 9 },
    { code: "+994", name: "Azerbaijan", length: 9 },
    { code: "+242", name: "Congo", length: 11 },
    { code: "+243", name: "Democratic Republic of the Congo", length: 9 },
    { code: "+45", name: "Denmark", length: 8 },
    { code: "+253", name: "Djibouti", length: 6 },
    { code: "+1", name: "Dominica", length: 10 },
    { code: "+1829", name: "Dominican Republic", length: 10 },
    { code: "+593", name: "Ecuador", length: 9 },
    { code: "+20", name: "Egypt", length: 10 },
    { code: "+503", name: "El Salvador", length: 8 },
    { code: "+240", name: "Equatorial Guinea", length: 9 },
    { code: "+291", name: "Eritrea", length: 9 },
    { code: "+372", name: "Estonia", length: 8 },
    { code: "+268", name: "Eswatini", length: 8 },
    { code: "+251", name: "Ethiopia", length: 9 },
    { code: "+500", name: "Falkland Islands", length: 4 },
    { code: "+298", name: "Faroe Islands", length: 6 },
    { code: "+679", name: "Fiji", length: 7 },
    { code: "+358", name: "Finland", length: 10 },
    { code: "+33", name: "France", length: 9 },
    { code: "+594", name: "French Guiana", length: 9 },
    { code: "+689", name: "French Polynesia", length: 7 },
    { code: "+241", name: "Gabon", length: 7 },
    {code : "+64", name : "New Zealand", length : 10},
    { code: "+220", name: "Gambia", length: 7 },
    { code: "+995", name: "Georgia", length: 9 },
    { code: "+49", name: "Germany", length: 11 },
    { code: "+233", name: "Ghana", length: 9 },
    { code: "+350", name: "Gibraltar", length: 8 },
    { code: "+30", name: "Greece", length: 10 },
    { code: "+299", name: "Greenland", length: 6 },
    { code: "+1", name: "Grenada", length: 10 },
    { code: "+224", name: "Guinea", length: 9 },
    { code: "+245", name: "Guinea-Bissau", length: 8 },
    { code: "+592", name: "Guyana", length: 7 },
    { code: "+509", name: "Haiti", length: 8 },
    { code: "+504", name: "Honduras", length: 8 },
    { code: "+36", name: "Hungary", length: 9 },
    { code: "+354", name: "Iceland", length: 7 },
    { code: "+91", name: "India", length: 10 },
    { code: "+62", name: "Indonesia", length: 10 },
    { code: "+98", name: "Iran", length: 10 },
    { code: "+964", name: "Iraq", length: 10 },
    { code: "+353", name: "Ireland", length: 9 },
    { code: "+972", name: "Israel", length: 9 },
    { code: "+39", name: "Italy", length: 10 },
    { code: "+225", name: "Ivory Coast", length: 10 },
    { code: "+1", name: "Jamaica", length: 10 },
    { code: "+81", name: "Japan", length: 10 },
    { code: "+962", name: "Jordan", length: 9 },
    { code: "+7", name: "Kazakhstan", length: 11 },
    { code: "+254", name: "Kenya", length: 9 },
    { code: "+686", name: "Kiribati", length: 7 },
    { code: "+850", name: "North Korea", length: 8 },
    { code: "+82", name: "South Korea", length: 10 },
    { code: "+965", name: "Kuwait", length: 8 },
    { code: "+996", name: "Kyrgyzstan", length: 9 },
    { code: "+856", name: "Laos", length: 8 },
    { code: "+371", name: "Latvia", length: 8 },
    { code: "+961", name: "Lebanon", length: 8 },
    { code: "+266", name: "Lesotho", length: 8 },
    { code: "+231", name: "Liberia", length: 7 },
    { code: "+218", name: "Libya", length: 9 },
    { code: "+423", name: "Liechtenstein", length: 9 },
    { code: "+370", name: "Lithuania", length: 8 },
    { code: "+352", name: "Luxembourg", length: 6 },
    { code: "+261", name: "Madagascar", length: 9 },
    { code: "+265", name: "Malawi", length: 9 },
    { code: "+60", name: "Malaysia", length: 9 },
    { code: "+960", name: "Maldives", length: 7 },
    { code: "+223", name: "Mali", length: 8 },
    { code: "+356", name: "Malta", length: 8 },
    { code: "+692", name: "Marshall Islands", length: 7 },
    { code: "+596", name: "Martinique", length: 10 },
    { code: "+230", name: "Mauritius", length: 10 },
    { code: "+262", name: "Mayotte", length: 9 },
    { code: "+52", name: "Mexico", length: 10 },
    { code: "+691", name: "Micronesia", length: 7 },
    { code: "+373", name: "Moldova", length: 8 },
    { code: "+377", name: "Monaco", length: 8 },
    { code: "+976", name: "Mongolia", length: 8 },
    { code: "+382", name: "Montenegro", length: 8 },
    { code: "+1664", name: "Montserrat", length: 10 },
    { code: "+212", name: "Morocco", length: 9 },
    { code: "+258", name: "Mozambique", length: 9 },
    { code: "+95", name: "Myanmar", length: 9 },
    { code: "+264", name: "Namibia", length: 9 },
    { code: "+674", name: "Nauru", length: 7 },
    { code: "+977", name: "Nepal", length: 10 },
    { code: "+31", name: "Netherlands", length: 9 },
    { code: "+687", name: "New Caledonia", length: 6 },
    { code: "+64", name: "New Zealand", length: 9 },
    { code: "+505", name: "Nicaragua", length: 8 },
    { code: "+227", name: "Niger", length: 8 },
    { code: "+234", name: "Nigeria", length: 10 },
    { code: "+683", name: "Niue", length: 5 },
    { code: "+672", name: "Norfolk Island", length: 4 },
    { code: "+47", name: "Norway", length: 8 },
    { code: "+968", name: "Oman", length: 8 },
    { code: "+92", name: "Pakistan", length: 10 },
    { code: "+680", name: "Palau", length: 7 },
    { code: "+970", name: "Palestine", length: 9 },
    { code: "+507", name: "Panama", length: 8 },
    { code: "+675", name: "Papua New Guinea", length: 9 },
    { code: "+595", name: "Paraguay", length: 9 },
    { code: "+51", name: "Peru", length: 9 },
    { code: "+63", name: "Philippines", length: 10 },
    { code: "+48", name: "Poland", length: 9 },
    { code: "+351", name: "Portugal", length: 9 },
    { code: "+1", name: "Puerto Rico", length: 10 },
    { code: "+974", name: "Qatar", length: 8 },
    { code: "+40", name: "Romania", length: 10 },
    { code: "+7", name: "Russia", length: 11 },
    { code: "+250", name: "Rwanda", length: 9 },
    { code: "+685", name: "Samoa", length: 7 },
    { code: "+378", name: "San Marino", length: 9 },
    { code: "+239", name: "Sao Tome and Principe", length: 9 },
    { code: "+966", name: "Saudi Arabia", length: 9 },
    { code: "+221", name: "Senegal", length: 9 },
    { code: "+381", name: "Serbia", length: 9 },
    { code: "+248", name: "Seychelles", length: 6 },
    { code: "+232", name: "Sierra Leone", length: 9 },
    { code: "+65", name: "Singapore", length: 8 },
    { code: "+421", name: "Slovakia", length: 9 },
    { code: "+386", name: "Slovenia", length: 8 },
    { code: "+677", name: "Solomon Islands", length: 7 },
    { code: "+252", name: "Somalia", length: 6 },
    { code: "+27", name: "South Africa", length: 10 },
    { code: "+34", name: "Spain", length: 9 },
    { code: "+94", name: "Sri Lanka", length: 10 },
    { code: "+249", name: "Sudan", length: 9 },
    { code: "+597", name: "Suriname", length: 7 },
    { code: "+268", name: "Eswatini", length: 8 },
    { code: "+46", name: "Sweden", length: 10 },
    { code: "+41", name: "Switzerland", length: 9 },
    { code: "+963", name: "Syria", length: 9 },
    { code: "+886", name: "Taiwan", length: 10 },
    { code: "+992", name: "Tajikistan", length: 9 },
    { code: "+255", name: "Tanzania", length: 9 },
    { code: "+66", name: "Thailand", length: 9 },
    { code: "+670", name: "Timor-Leste", length: 8 },
    { code: "+228", name: "Togo", length: 7 },
    { code: "+690", name: "Tokelau", length: 4 },
    { code: "+676", name: "Tonga", length: 4 },
    { code: "+1", name: "Trinidad and Tobago", length: 10 },
    { code: "+216", name: "Tunisia", length: 8 },
    { code: "+90", name: "Turkey", length: 10 },
    { code: "+993", name: "Turkmenistan", length: 9 },
    { code: "+1", name: "Turks and Caicos Islands", length: 10 },
    { code: "+688", name: "Tuvalu", length: 5 },
    { code: "+256", name: "Uganda", length: 9 },
    { code: "+380", name: "Ukraine", length: 9 },
    { code: "+971", name: "United Arab Emirates", length: 9 },
    { code: "+44", name: "United Kingdom", length: 10 },
    { code: "+1", name: "United States", length: 10 },
    { code: "+598", name: "Uruguay", length: 8 },
    { code: "+998", name: "Uzbekistan", length: 9 },
    { code: "+678", name: "Vanuatu", length: 7 },
    { code: "+58", name: "Venezuela", length: 10 },
    { code: "+84", name: "Vietnam", length: 10 },
    { code: "+681", name: "Wallis and Futuna", length: 6 },
    { code: "+967", name: "Yemen", length: 9 },
    { code: "+260", name: "Zambia", length: 9 },
    { code: "+263", name: "Zimbabwe", length: 9 }
];
